import { Language } from '@ha/intl';
import { GoogleOptimizeDataLayer } from 'ha/constants/GoogleOptimizeDataLayer';
import { LocalStorage } from 'ha/constants/LocalStorage';
import { SessionStorage } from 'ha/constants/SessionStorage';
import { GlobalState } from 'ha/types/store';
import { getFromStorage, setInStorage } from 'ha/utils/storage';

const getLocation = (
  globalState: GlobalState,
): {
  countryCode: string;
  city: string;
} => {
  if (globalState.search?.loadState) {
    const { countryCode, cityCanonical: city } = globalState.search.loadState;
    return { countryCode, city };
  }
  if (globalState.listing?.entity) {
    const { countryCode, city } = globalState.listing.entity;
    return { countryCode, city };
  }
  return {
    countryCode: '',
    city: '',
  };
};

export const getFillDataLayerScript = (
  preloadedState: {},
  lang: Language,
): string => {
  let { countryCode, city } = { countryCode: '', city: '' };
  try {
    const globalState = (preloadedState as GlobalState) ?? {};
    ({ countryCode, city } = getLocation(globalState));
    // eslint-disable-next-line no-empty
  } catch {}

  return `window.dataLayer = [{
    '${GoogleOptimizeDataLayer.HAS_EVER_LOGGED_IN}': (window.localStorage.getItem('${LocalStorage.HAS_EVER_LOGGED_IN}') === 'true'),
    '${GoogleOptimizeDataLayer.LANGUAGE}': '${lang}',
    '${GoogleOptimizeDataLayer.COUNTRY_CODE}': ('${countryCode}' ? '${countryCode}' : window.sessionStorage.getItem('${SessionStorage.COUNTRY_CODE}')) ?? '',
    '${GoogleOptimizeDataLayer.CITY_CANONICAL}': ('${city}' ? '${city}' : window.sessionStorage.getItem('${SessionStorage.CITY_CANONICAL}')) ?? ''
  }];`;
};

export const getGoogleTagScript = (): string => `
  function gtag() {
    window.dataLayer = window.dataLayer || [];
    dataLayer.push(arguments);
  }`;

export const updateHasEverLoggedIn = () => {
  const hasEverLoggedInKey = LocalStorage.HAS_EVER_LOGGED_IN;
  if (!getFromStorage(hasEverLoggedInKey)) {
    setInStorage(hasEverLoggedInKey, true);

    const { dataLayer } = window as any;
    if (dataLayer?.length > 0) {
      dataLayer[0][`${GoogleOptimizeDataLayer.HAS_EVER_LOGGED_IN}`] = true;
    }
  }
};
